import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import {
	ANCHOR_STATUS,
	useAnchorGeneratedFamiliesReviewMutation,
} from '@/entities/anchor'

import { Operators } from '@/shared/components/query-builder'
import { ampli } from '@/shared/lib/ampli'
import { queryClient } from '@/shared/lib/query-client'
import { processingMessage } from '@/shared/tools/message'

export const useApproveAnchorFamily = () => {
	const { t } = useTranslation()

	const anchorGeneratedFamiliesReviewMutation =
		useAnchorGeneratedFamiliesReviewMutation({
			onSuccess: () => {
				queryClient.refetchQueries({
					queryKey: ['generated-anchor-families'],
				})
			},
		})
	const handleApproveAnchorFamily = useCallback(
		(id: string) => {
			ampli.anchoringAnchorApprovalClickApprove()
			toast.promise(
				anchorGeneratedFamiliesReviewMutation.mutateAsync({
					filters: [
						{
							name: 'id',
							operation: Operators.IS,
							value: id,
						},
					],
					status: ANCHOR_STATUS.APPROVED,
				}),
				{
					loading: processingMessage(t),
					error: t('fatal_error_title'),
					success: t('toast.entity.updated', {
						entity: t('entity.anchor_family', {
							defaultValue: 'Anchor family',
						}),
					}),
					id: 'anchor_generated_family_status_updating',
				}
			)
		},
		[anchorGeneratedFamiliesReviewMutation, t]
	)

	return {
		handleApproveAnchorFamily,
		isPending: anchorGeneratedFamiliesReviewMutation.isPending,
	}
}
